import * as React from 'react';
import { UserRepository } from '../../MedicareProAPI/Repositories/User/UserRepository';
import { UserLetterRepository } from '../../MedicareProAPI/Repositories/User/UserLetterRepository';
import { StaffRepository } from '../../MedicareProAPI/Repositories/Staff/StaffRepository';
import { AgencyDownlineRepository } from '../../MedicareProAPI/Repositories/Agency/AgencyDownlineRepository';
import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import StyledModal from './StyledModal';
import RichTextEditor from './Form/Field/RichTextEditor';
import type { User } from '../../MedicareProAPI/Entities/User/User';
import { WebAPI } from '../../MedicareProAPI/API/WebAPI';
import type { UserLetter } from '../../MedicareProAPI/Entities/User/UserLetter';
import type { IndNote } from '../../MedicareProAPI/Entities/Ind/IndNote';

// Props interface defining expected inputs
export interface NativeEmailsProps {
  noteEmails: Array<IndNote>;
  emails: Array<string>;
  userAccessToken: string;
  targetUser: User;
  staffId?: number;
  agencyId?: number;
  signature?: string;
  // templates?: Array<UserLetter>
  authorizedUsers: Array<User>;
  mailPlatform: any;
  onTargetUserChange: (targetUserId: number) => void;
  onTemplateChange: (templateIndex: number) => Promise<any>;
}

export const NativeEmails = ({
  noteEmails,
  emails,
  userAccessToken,
  targetUser,
  staffId,
  agencyId,
  signature,
  // templates,
  authorizedUsers,
  mailPlatform,
  onTargetUserChange,
  onTemplateChange,
}: NativeEmailsProps): React.JSX.Element => {
  const userRepository = new UserRepository();
  userRepository.setAccessToken(userAccessToken);

  const userLetterRepository = new UserLetterRepository();
  userLetterRepository.setAccessToken(userAccessToken);

  const staffRepository = new StaffRepository();
  staffRepository.setAccessToken(userAccessToken);

  const agencyDownlineRepository = new AgencyDownlineRepository();
  agencyDownlineRepository.setAccessToken(userAccessToken);

  const webAPI = new WebAPI();
  webAPI.setAccessToken(userAccessToken);
  console.log('vendor');
  const [emailAddress, setEmailAddress] = React.useState<string>(emails?.[0] || '');
  const [emailAddresses, setEmailAddresses] = React.useState<Array<string>>(emails);

  const [mailThreadID, setMailThreadID] = React.useState<number>(null);
  const [mailThreads, setMailThreads] = React.useState<Array<any>>(noteEmails);
  const [mailThreadsLoading, setMailThreadsLoading] = React.useState<boolean>(false);
  const [mailThreadsErrorMessage, setMailThreadsErrorMessage] = React.useState<boolean>(false);

  const [messageSelected, setMessageSelected] = React.useState<any>(
    noteEmails ? noteEmails[0] : ''
  );
  const [selectedMessageId, setSelectedMessageId] = React.useState<number>(
    noteEmails ? noteEmails[0]?.getId() : 0
  );
  const [mailMessages, setMailMessages] = React.useState<Array<any>>();
  const [mailMessagesLoading, setMailMessagesLoading] = React.useState<boolean>(null);

  const [savingAttachment, setSavingAttachment] = React.useState<boolean>(null);

  const composeMessageCCElement = React.useRef<HTMLInputElement | null>(null);
  const [composeMessageModal, setComposeMessageModal] = React.useState<boolean>(false);
  const [composeMessage, setComposeMessage] = React.useState<any>(null);
  const [composeMessageTo, setComposeMessageTo] = React.useState<Array<string>>(null);
  const [composeMessageCC, setComposeMessageCC] = React.useState<Array<string>>(null);
  const [composeMessageSubject, setComposeMessageSubject] = React.useState<string>(null);
  const [composeMessageBody, setComposeMessageBody] = React.useState<string>(null);
  const [composeMessageSending, setComposeMessageSending] = React.useState<boolean>(null);
  const [composeMessageSent, setComposeMessageSent] = React.useState<boolean>(false);

  const [selectedEmailTemplate, setSelectedEmailTemplate] = React.useState<number>(null);

  const [changingTargetUser, setChangingTargetUser] = React.useState<boolean>(false);

  const [targetUserName, setTargetUserName] = React.useState<string>(
    targetUser.getUserFirstname() + ' ' + targetUser.getUserLastname()
  );

  const userEmailTemplates: UserLetter[] = targetUser.getLetters().getItems();
  const emailTemplates = userEmailTemplates.filter(
    (t) => t.getLetterType()?.toLowerCase() === 'email'
  );

  const saveAttachment = (emailId, attachmentId) => {
    setSavingAttachment(true);

    /* webAPI.saveUserIntegrationMailAttachment(mailPlatform, emailId, attachmentId, {indId: ind.getIndId()})
            .then(response => {
                setSavingAttachment(false);
            }) */
  };

  const loadEmail = (threadIndex) => {
    setMessageSelected(mailThreads[threadIndex]);
    setSelectedMessageId(mailThreads[threadIndex].getId());
    /* setMailMessagesLoading(true);
        setMailMessageID(null);
        setMailThreadID(mailThreads[threadIndex].getId());
        setMailMessages([mailThreads[threadIndex]]);
        console.log(mailThreads[threadIndex]); */
  };

  const loadCompose = (email = null, subject = null) => {
    setComposeMessageSubject(subject);
    //setComposeMessageBody(null);

    signature ? setComposeMessageBody(signature) : null;

    setComposeMessage(email);
    setComposeMessageModal(true);

    if (email) {
      if (Array.isArray(email.replyTo) && email.replyTo.length > 0) {
        setComposeMessageTo(email.replyTo.map((toEmail) => toEmail.email));
      } else if (email.from?.email) {
        setComposeMessageTo([email.from.email]);
      }

      if (Array.isArray(email.replyCC)) {
        setComposeMessageCC(email.replyCC.map((ccEmail) => ccEmail.email));
      }
    }

    setComposeMessageSending(null);
    setComposeMessageSent(false);
  };

  const sendEmail = () => {
    setComposeMessageSending(true);

    const payload = {
      to: [{ email: emailAddress }],
      from: {
        email: targetUser.getUserUsername(),
        name: targetUser.getUserFirstname() + ' ' + targetUser.getUserLastname(),
      },
      subject: composeMessageSubject,
      message: composeMessageBody,
      cc: composeMessageCC,
    };

    webAPI.nativeEmailSend(payload).then((response) => {
      setComposeMessageSubject(null);
      setComposeMessageBody(null);

      setComposeMessageSending(false);
      setComposeMessageSent(true);
    });
  };

  const loadEmailTemplates = () => {
    /* if (targetUser) {
            console.log('loadU: PNLEM');
            userRepository.getUser(targetUser, {
                include: ['letters', 'signatureEmail']
            }).then(templates => {
                setUser(templates);
                setUserEmailTemplates(templates.getLetters())
                setUserEmailSignature(templates.getSignatureEmail())
                     
            })
        }*/
  };

  const handleSelectedEmailTemplate = async (event) => {
    setSelectedEmailTemplate(parseInt(event));
    const templateData: any = await onTemplateChange(parseInt(event));
    setComposeMessageBody(templateData.renderedBody);
    setComposeMessageSubject(
      templateData.template.getLetterSubject() || templateData.template.getLetterTitle()
    );
  };

  const handleDeleteCC = (address) => {
    const newCC = [...composeMessageCC];
    const currentCCIndex = newCC.indexOf(address);
    if (currentCCIndex > -1) {
      newCC.splice(currentCCIndex, 1);
    }

    setComposeMessageCC(newCC);
    composeMessageCCElement.current.focus();
  };

  const handleChangeCC = (event) => {
    const value = event.target.value;
    if (value && ((event.type === 'keyup' && event.which === 13) || event.type === 'blur')) {
      const emailValid = Utilities.validateEmail(value);

      if (emailValid) {
        if (composeMessageCC === null || !composeMessageCC.includes(value)) {
          let newCC = [];

          composeMessageCC ? (newCC = [...composeMessageCC]) : '';

          newCC.push(value);

          setComposeMessageCC(newCC);
        }

        event.target.value = '';
        event.target.focus();
      }
    }
  };

  return (
    <>
      <StyledModal
        size="lg"
        title={composeMessage ? 'Reply to Email' : 'Compose New Email'}
        footerCloseButton={true}
        show={composeMessageModal}
        onClose={(e) => {
          setComposeMessage(null);
          setComposeMessageTo(null);
          setComposeMessageCC(null);
          setComposeMessageSubject(null);
          setComposeMessageModal(false);
        }}
      >
        {composeMessageSent ? (
          <>
            <div className="alert small alert-success" role="alert">
              Your email was sent successfully
            </div>
          </>
        ) : (
          <>
            <div className="row">
              {authorizedUsers.length > 0 && (
                <div className="col-12 mt-0 ">
                  <div
                    className="badge badge-primary dataBadge float-right"
                    style={{ fontSize: '10pt' }}
                  >
                    <i className="far fa-inbox"></i> {targetUserName}
                  </div>
                </div>
              )}
              <div className="col-12 col-lg-6 mt-2">
                <label className="label">To</label>
                {composeMessage ? (
                  <div className="form-control border-secondary d-inline-flex flex-wrap mb-2 pl-2 form-control-tags pt-1">
                    {composeMessageTo.map((toAddress) => (
                      <div
                        onClick={(e) => e.stopPropagation()}
                        className="badge bg-info text-white mt-0 mr-1 my-auto py-auto"
                      >
                        {toAddress}
                      </div>
                    ))}
                  </div>
                ) : (
                  <select
                    className="form-control form-control-sm"
                    value={emailAddress}
                    onChange={(e) => setEmailAddress(e.target.value)}
                  >
                    {emailAddresses &&
                      emailAddresses.map((emailSingle) => (
                        <option value={emailSingle}>{emailSingle}</option>
                      ))}
                  </select>
                )}
              </div>
              <div className="col-12 col-lg-6 mt-2">
                <label className="label">CC</label>
                <div
                  onClick={(e) => composeMessageCCElement.current.focus()}
                  className="form-control border-secondary d-inline-flex flex-wrap mb-2 pl-2 form-control-tags pt-1"
                >
                  {composeMessageCC &&
                    composeMessageCC.map((ccAddress) => (
                      <div
                        onClick={(e) => e.stopPropagation()}
                        style={{ fontSize: '9pt' }}
                        className="badge bg-info text-white mt-0 mr-1 my-auto py-auto"
                      >
                        {ccAddress}{' '}
                        <i
                          onClick={(e) => handleDeleteCC(ccAddress)}
                          className="fa fa-trash ml-1"
                        ></i>
                      </div>
                    ))}

                  <input
                    type="text"
                    className="border-0 w-auto flex-fill input-tags"
                    autoComplete="off"
                    onKeyUp={handleChangeCC}
                    onBlur={handleChangeCC}
                    ref={composeMessageCCElement}
                    style={{ fontSize: '9pt' }}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6 mt-2">
                <label className="label">Templates</label>
                <div className="input-group input-group-sm mb-2">
                  <select
                    className="form-control form-control-sm"
                    onChange={(e) => handleSelectedEmailTemplate(e.target.value)}
                  >
                    <>
                      <option>Select...</option>
                      {emailTemplates.length > 0
                        ? emailTemplates.map((template, index) => (
                            <option key={index} value={template.getLetterId()}>
                              {template.getLetterTitle()}
                            </option>
                          ))
                        : loadEmailTemplates()}
                    </>
                  </select>
                </div>
              </div>
            </div>
            <div>
              <label className="label">{composeMessage ? 'Replying to' : 'Subject'}</label>
              <div className="input-group input-group-sm mb-2">
                <input
                  type="text"
                  onChange={(e) => setComposeMessageSubject(e.target.value)}
                  className="form-control border-secondary"
                  value={composeMessage ? composeMessage.subject : composeMessageSubject}
                  disabled={composeMessage === ''}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="mt-2">
              <label className="label">Message</label>
              <RichTextEditor
                value={composeMessageBody}
                onEditorChange={(e) => setComposeMessageBody(e)}
              />
            </div>
            <div className="mt-2">
              <label className="label">
                Attachments <i className="fas fa-plus-circle ml-2"></i>
              </label>
            </div>

            <button
              onClick={sendEmail}
              disabled={
                !composeMessage
                  ? !composeMessageBody || !composeMessageSubject
                  : !composeMessageBody
              }
              className="btn btn-primary mt-2"
            >
              {composeMessageSending === true ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> Sending
                </>
              ) : (
                <>Send Email</>
              )}
            </button>
          </>
        )}
      </StyledModal>
      <StyledModal
        size="lg"
        title={'Save Attachment'}
        footerCloseButton={true}
        show={savingAttachment !== null}
        onClose={(e) => {
          setSavingAttachment(null);
        }}
      >
        {savingAttachment ? (
          <div className="alert small alert-info" role="alert">
            <i className="fas fa-spinner fa-spin"></i> Saving attachment to client documents
            section.
          </div>
        ) : (
          <div className="alert small alert-success" role="alert">
            Attachment saved!
          </div>
        )}
      </StyledModal>
      <div className="row email-log pt-2">
        {mailPlatform && (
          <>
            {mailThreadsLoading && !changingTargetUser && (
              <div className="col-12">
                <i className="fas fa-spinner fa-spin ml-2"></i>
              </div>
            )}

            <div className="col-3 email-log-threads">
              <img
                className="mb-2"
                src={`https://medicareprocrm-cdn.s3.us-east-2.amazonaws.com/public/img/site/mpcrmicon.png`}
                style={{ height: '35px' }}
              ></img>
              <div
                className="btn border border-primary d-block mb-2 w-100"
                onClick={(e) => loadCompose()}
              >
                <i className="fal fa-plus-circle text-primary "></i>
                <span className="d-none d-sm-inline ml-2 text-primary">New Email</span>
              </div>
              {authorizedUsers.length > 0 && (
                <>
                  <label className="label">Inbox</label>
                  <select
                    className="form-control form-control-sm mb-2"
                    onChange={(e) => onTargetUserChange(parseInt(e.target.value))}
                  >
                    {authorizedUsers.map((user) => {
                      return (
                        <option selected={user.getUserId() === targetUser} value={user.getUserId()}>
                          {user.getUserFirstname()} {user.getUserLastname()}
                        </option>
                      );
                    })}
                  </select>
                </>
              )}
              {mailPlatform !== undefined &&
                !changingTargetUser &&
                noteEmails.map((mailThread, threadIndex) => {
                  const classList = [
                    'small',
                    'card',
                    'p-2',
                    'mb-2',
                    'email-log-threads-thread',
                    'cp',
                  ];

                  const dateTime = Utilities.dateTimeStringToDateTime(mailThread.getIndNoteDate());

                  const timesince = Utilities.getTimeSince(dateTime, true);

                  if (mailThread.getId() === selectedMessageId) {
                    classList.push('bg-info');
                    classList.push('text-white');
                  }

                  return (
                    <div
                      onClick={(e) => loadEmail(threadIndex)}
                      key={mailThread.getId()}
                      className={classList.join(' ')}
                    >
                      <div>
                        <span className="float-right small mt-1">{timesince}</span>
                        <p>
                          <strong>{mailThread.getIndNoteAuthor() || ''}</strong>
                        </p>
                        <p className={mailThread.getId() === mailThreadID ? '' : ''}>
                          {mailThread.getIndNoteBody().substr(0, 25)}
                        </p>
                      </div>
                    </div>
                  );
                })}
              {changingTargetUser && <i className="fas fa-spinner fa-spin ml-2"></i>}
            </div>
            <div className="col-9 email-log-messages">
              {/* authorizedUsers.length > 0 && 
                                            <div className="mb-2">
                                                <div className="badge badge-primary dataBadge" style={{fontSize:'10pt'}}><i className="far fa-inbox"></i> {targetUserName}</div>
                                            </div> */}

              {mailMessagesLoading === true && <i className="fas fa-spinner fa-spin ml-2"></i>}
              {messageSelected &&
                !changingTargetUser &&
                (() => {
                  const classList = ['card', 'p-2', 'mb-2', 'bg-white'];
                  const dateTime = Utilities.dateTimeStringToDateTime(
                    messageSelected.getIndNoteDate()
                  );
                  const timesince = Utilities.getTimeSince(dateTime);

                  return (
                    <div className="email-log-messages-message">
                      <div className={classList.join(' ')}>
                        <div>
                          <span className="float-right small mt-1">{timesince}</span>
                          <p>
                            <strong>{messageSelected.getIndNoteAuthor() || ''}</strong>
                          </p>
                          <div className="mt-1">
                            <p>{messageSelected.getIndNoteBody()}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}
            </div>
          </>
        )}
        {emailAddresses && emailAddresses.length === 0 && (
          <div className="col-12">
            <div className="alert small alert-info" role="alert">
              Client has no email address.
            </div>
          </div>
        )}
        {mailThreadsErrorMessage && (
          <div className="col-12">
            <div className="alert small alert-warning" role="alert">
              {mailThreadsErrorMessage}
            </div>
          </div>
        )}
        {!mailThreadsErrorMessage &&
          !mailThreadsLoading &&
          !mailThreads &&
          emailAddresses &&
          emailAddresses.length > 0 && (
            <div className="col-12">
              <div className="alert small alert-info" role="alert">
                No emails to show.{' '}
                <a
                  href=""
                  onClick={(e) => {
                    e.preventDefault();
                    loadCompose();
                  }}
                >
                  Click here
                </a>{' '}
                to compose a new email.
              </div>

              {authorizedUsers.length > 0 && (
                <>
                  <label className="label">Change Inbox</label>
                  <select
                    className="form-control form-control-sm mb-2"
                    onChange={(e) => onTargetUserChange(parseInt(e.target.value))}
                  >
                    {authorizedUsers.map((user) => {
                      return (
                        <option selected={user.getUserId() === targetUser} value={user.getUserId()}>
                          {user.getUserFirstname()} {user.getUserLastname()}
                        </option>
                      );
                    })}
                  </select>
                </>
              )}
            </div>
          )}
      </div>
    </>
  );
};
